// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.call-control {
  padding: 20px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
}

.call-control h2 {
  font-size: 18px;
  margin-bottom: 16px;
  color: #333;
}

.error-message {
  background-color: #ffebee;
  border-left: 4px solid #d32f2f;
  color: #d32f2f;
  padding: 12px;
  border-radius: 4px;
  margin-bottom: 16px;
  font-size: 13px;
}

.no-calls {
  color: #999;
  font-style: italic;
  margin-top: 20px;
}

/* Mode toggle (Manual / IVR) */
.call-mode-toggle {
  display: inline-flex;
  background: #f3f4f6;
  border-radius: 8px;
  padding: 3px;
  margin-bottom: 16px;
  gap: 2px;
}

.call-mode-tab {
  background: transparent;
  border: none;
  padding: 6px 14px;
  font-size: 13px;
  font-weight: 600;
  color: #6b7280;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
}

.call-mode-tab:hover:not(.active) {
  color: #374151;
}

.call-mode-tab.active {
  background: white;
  color: #1f2937;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

/* Advanced options disclosure */
.advanced-toggle {
  background: none;
  border: none;
  padding: 4px 0;
  font-size: 12px;
  color: #6b7280;
  cursor: pointer;
  text-align: left;
  align-self: flex-start;
}

.advanced-toggle:hover {
  color: #374151;
}

.advanced-options {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 12px 14px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
}

/* IVR inline result panel */
.ivr-inline-result {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  background: #ecfdf5;
  border: 1px solid #a7f3d0;
  border-radius: 8px;
}

.ivr-inline-result-header {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #065f46;
}

.ivr-inline-result-icon {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #10b981;
  color: white;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 13px;
  flex-shrink: 0;
}

.ivr-inline-result-grid {
  display: grid;
  grid-template-columns: 80px 1fr;
  gap: 6px 12px;
  margin: 0;
  font-size: 12px;
}

.ivr-inline-result-grid dt {
  color: #6b7280;
  font-weight: 600;
}

.ivr-inline-result-grid dd {
  margin: 0;
  color: #1f2937;
  word-break: break-all;
}

.ivr-inline-result-grid dd.mono {
  font-family: 'Monaco', 'Courier New', monospace;
  font-size: 11px;
}

/* Outgoing Call */
.call-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.call-input-group {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.call-input-group label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #374151;
}

.call-input-group input[type="text"],
.call-input-group input[type="tel"],
.call-input-group select {
  padding: 0.5rem 0.75rem;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  font-size: 1rem;
}

.call-input-group input:focus,
.call-input-group select:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.2);
}

.call-input-group input:disabled,
.call-input-group select:disabled {
  background-color: #f3f4f6;
  opacity: 0.6;
}

.checkbox-group label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
}

.checkbox-group input[type="checkbox"] {
  width: 1rem;
  height: 1rem;
}

.input-hint {
  color: #6b7280;
  font-size: 0.75rem;
}

.custom-params-textarea {
  padding: 0.5rem 0.75rem;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-family: monospace;
  resize: vertical;
}

.custom-params-textarea:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.2);
}

.patient-guid {
  font-size: 0.875rem;
  color: #6b7280;
}

.active-call {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 20px;
  background-color: #e8f5e9;
  border-radius: 6px;
}

.call-info {
  flex: 1;
}

.calling-to {
  font-size: 16px;
  font-weight: 600;
  color: #2e7d32;
  margin-bottom: 4px;
}

.call-status {
  font-size: 13px;
  color: #558b2f;
  font-weight: 500;
}

/* Incoming Call */
.incoming-call {
  position: relative;
}

.incoming-call.active {
  background-color: #fff3e0;
  border: 2px solid #ff9800;
}

.ringing-indicator {
  display: flex;
  gap: 6px;
  margin-bottom: 12px;
  justify-content: center;
}

.pulse {
  width: 8px;
  height: 8px;
  background-color: #ff9800;
  border-radius: 50%;
  animation: pulse 1.5s infinite;
}

.pulse:nth-child(2) {
  animation-delay: 0.2s;
}

.pulse:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.5;
    transform: scale(1.2);
  }
}

.calling-from {
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  color: #ff6f00;
}

.incoming-actions {
  display: flex;
  gap: 10px;
  justify-content: center;
  margin-top: 16px;
}

.incoming-actions button {
  flex: 1;
  max-width: 150px;
  padding: 12px 20px;
  font-size: 15px;
}

.call-controls-active {
  display: flex;
  gap: 10px;
  margin-top: 16px;
}

/* Button styles */
.btn-primary {
  background-color: #4CAF50;
  color: white;
  font-weight: 600;
  padding: 10px 20px;
}

.btn-primary:hover:not(:disabled) {
  background-color: #45a049;
}

.btn-primary:disabled {
  background-color: #cccccc;
}

.btn-success {
  background-color: #4CAF50;
  color: white;
  font-weight: 600;
  padding: 12px 24px;
}

.btn-success:hover:not(:disabled) {
  background-color: #45a049;
}

.btn-danger {
  background-color: #f44336;
  color: white;
  font-weight: 600;
  padding: 10px 20px;
}

.btn-danger:hover:not(:disabled) {
  background-color: #da190b;
}

.btn-warning {
  background-color: #ff9800;
  color: white;
  font-weight: 600;
  padding: 10px 20px;
}

.btn-warning:hover:not(:disabled) {
  background-color: #e68900;
}

.btn-secondary {
  background-color: #9e9e9e;
  color: white;
  font-weight: 600;
  padding: 10px 20px;
}

.btn-secondary:hover:not(:disabled) {
  background-color: #757575;
}

.call-actions {
  display: flex;
  gap: 10px;
  margin-top: 15px;
}

.call-actions .btn-warning,
.call-actions .btn-danger {
  flex: 1;
}
`, "",{"version":3,"sources":["webpack://./src/components/CallControls/CallControls.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,+BAA+B;AAC/B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,wCAAwC;AAC1C;;AAEA,gCAAgC;AAChC;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,+CAA+C;EAC/C,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;EAGE,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;;EAEE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,qBAAqB;EACvB;AACF;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,OAAO;AACT","sourcesContent":[".call-control {\n  padding: 20px;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  margin-bottom: 20px;\n}\n\n.call-control h2 {\n  font-size: 18px;\n  margin-bottom: 16px;\n  color: #333;\n}\n\n.error-message {\n  background-color: #ffebee;\n  border-left: 4px solid #d32f2f;\n  color: #d32f2f;\n  padding: 12px;\n  border-radius: 4px;\n  margin-bottom: 16px;\n  font-size: 13px;\n}\n\n.no-calls {\n  color: #999;\n  font-style: italic;\n  margin-top: 20px;\n}\n\n/* Mode toggle (Manual / IVR) */\n.call-mode-toggle {\n  display: inline-flex;\n  background: #f3f4f6;\n  border-radius: 8px;\n  padding: 3px;\n  margin-bottom: 16px;\n  gap: 2px;\n}\n\n.call-mode-tab {\n  background: transparent;\n  border: none;\n  padding: 6px 14px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #6b7280;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: background 0.15s, color 0.15s;\n}\n\n.call-mode-tab:hover:not(.active) {\n  color: #374151;\n}\n\n.call-mode-tab.active {\n  background: white;\n  color: #1f2937;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n}\n\n/* Advanced options disclosure */\n.advanced-toggle {\n  background: none;\n  border: none;\n  padding: 4px 0;\n  font-size: 12px;\n  color: #6b7280;\n  cursor: pointer;\n  text-align: left;\n  align-self: flex-start;\n}\n\n.advanced-toggle:hover {\n  color: #374151;\n}\n\n.advanced-options {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  padding: 12px 14px;\n  background: #f9fafb;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n}\n\n/* IVR inline result panel */\n.ivr-inline-result {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 16px;\n  background: #ecfdf5;\n  border: 1px solid #a7f3d0;\n  border-radius: 8px;\n}\n\n.ivr-inline-result-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  color: #065f46;\n}\n\n.ivr-inline-result-icon {\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  background: #10b981;\n  color: white;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  font-size: 13px;\n  flex-shrink: 0;\n}\n\n.ivr-inline-result-grid {\n  display: grid;\n  grid-template-columns: 80px 1fr;\n  gap: 6px 12px;\n  margin: 0;\n  font-size: 12px;\n}\n\n.ivr-inline-result-grid dt {\n  color: #6b7280;\n  font-weight: 600;\n}\n\n.ivr-inline-result-grid dd {\n  margin: 0;\n  color: #1f2937;\n  word-break: break-all;\n}\n\n.ivr-inline-result-grid dd.mono {\n  font-family: 'Monaco', 'Courier New', monospace;\n  font-size: 11px;\n}\n\n/* Outgoing Call */\n.call-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.call-input-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.call-input-group label {\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #374151;\n}\n\n.call-input-group input[type=\"text\"],\n.call-input-group input[type=\"tel\"],\n.call-input-group select {\n  padding: 0.5rem 0.75rem;\n  border: 1px solid #d1d5db;\n  border-radius: 0.375rem;\n  font-size: 1rem;\n}\n\n.call-input-group input:focus,\n.call-input-group select:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.2);\n}\n\n.call-input-group input:disabled,\n.call-input-group select:disabled {\n  background-color: #f3f4f6;\n  opacity: 0.6;\n}\n\n.checkbox-group label {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  cursor: pointer;\n}\n\n.checkbox-group input[type=\"checkbox\"] {\n  width: 1rem;\n  height: 1rem;\n}\n\n.input-hint {\n  color: #6b7280;\n  font-size: 0.75rem;\n}\n\n.custom-params-textarea {\n  padding: 0.5rem 0.75rem;\n  border: 1px solid #d1d5db;\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  font-family: monospace;\n  resize: vertical;\n}\n\n.custom-params-textarea:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.2);\n}\n\n.patient-guid {\n  font-size: 0.875rem;\n  color: #6b7280;\n}\n\n.active-call {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  padding: 20px;\n  background-color: #e8f5e9;\n  border-radius: 6px;\n}\n\n.call-info {\n  flex: 1;\n}\n\n.calling-to {\n  font-size: 16px;\n  font-weight: 600;\n  color: #2e7d32;\n  margin-bottom: 4px;\n}\n\n.call-status {\n  font-size: 13px;\n  color: #558b2f;\n  font-weight: 500;\n}\n\n/* Incoming Call */\n.incoming-call {\n  position: relative;\n}\n\n.incoming-call.active {\n  background-color: #fff3e0;\n  border: 2px solid #ff9800;\n}\n\n.ringing-indicator {\n  display: flex;\n  gap: 6px;\n  margin-bottom: 12px;\n  justify-content: center;\n}\n\n.pulse {\n  width: 8px;\n  height: 8px;\n  background-color: #ff9800;\n  border-radius: 50%;\n  animation: pulse 1.5s infinite;\n}\n\n.pulse:nth-child(2) {\n  animation-delay: 0.2s;\n}\n\n.pulse:nth-child(3) {\n  animation-delay: 0.4s;\n}\n\n@keyframes pulse {\n  0%, 100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n  50% {\n    opacity: 0.5;\n    transform: scale(1.2);\n  }\n}\n\n.calling-from {\n  text-align: center;\n  font-size: 16px;\n  font-weight: 600;\n  color: #ff6f00;\n}\n\n.incoming-actions {\n  display: flex;\n  gap: 10px;\n  justify-content: center;\n  margin-top: 16px;\n}\n\n.incoming-actions button {\n  flex: 1;\n  max-width: 150px;\n  padding: 12px 20px;\n  font-size: 15px;\n}\n\n.call-controls-active {\n  display: flex;\n  gap: 10px;\n  margin-top: 16px;\n}\n\n/* Button styles */\n.btn-primary {\n  background-color: #4CAF50;\n  color: white;\n  font-weight: 600;\n  padding: 10px 20px;\n}\n\n.btn-primary:hover:not(:disabled) {\n  background-color: #45a049;\n}\n\n.btn-primary:disabled {\n  background-color: #cccccc;\n}\n\n.btn-success {\n  background-color: #4CAF50;\n  color: white;\n  font-weight: 600;\n  padding: 12px 24px;\n}\n\n.btn-success:hover:not(:disabled) {\n  background-color: #45a049;\n}\n\n.btn-danger {\n  background-color: #f44336;\n  color: white;\n  font-weight: 600;\n  padding: 10px 20px;\n}\n\n.btn-danger:hover:not(:disabled) {\n  background-color: #da190b;\n}\n\n.btn-warning {\n  background-color: #ff9800;\n  color: white;\n  font-weight: 600;\n  padding: 10px 20px;\n}\n\n.btn-warning:hover:not(:disabled) {\n  background-color: #e68900;\n}\n\n.btn-secondary {\n  background-color: #9e9e9e;\n  color: white;\n  font-weight: 600;\n  padding: 10px 20px;\n}\n\n.btn-secondary:hover:not(:disabled) {\n  background-color: #757575;\n}\n\n.call-actions {\n  display: flex;\n  gap: 10px;\n  margin-top: 15px;\n}\n\n.call-actions .btn-warning,\n.call-actions .btn-danger {\n  flex: 1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
